import FeedbackComment from './feedback-comment.js';

export default FeedbackComment;
